/**
 * Scroll-to-links
 */
document.addEventListener("DOMContentLoaded", function () {
  // Handle Hash in Url on first load
  const hash = document.location.hash.split("#")[1];
  if (hash && isUrlToCurrentPage(document.location.href)) {
    setTimeout(() => {
      scrollToElementByID(hash);
    }, 500);
  }

  // Handle Clicks
  document.body.addEventListener(
    "click",
    function (evt) {
      if (evt.target.nodeName === "A") {
        const href = evt.target.getAttribute("href") || "";
        const hash = href.split("#")[1];

        // noch checken ob man auf der richtigen Seite ist
        if (hash && isUrlToCurrentPage(href)) {
          scrollToElementByID(hash);
        }
      }
    },
    false
  );

  /**
   * Is this URL directing to the Path of the current page?
   * @param {string} url
   * @returns boolen
   */
  function isUrlToCurrentPage(url) {
    const base = window.location.protocol + window.location.host;
    const targetPathname = new URL(url, base).pathname;
    return (
      targetPathname === window.location.pathname ||
      url[0] === "#" ||
      url.substring(0, 2) === "/#"
    );
  }

  // animate Page to element with the right ID
  function scrollToElementByID(elementId, behavior = "smooth") {
    // is Hash on same page
    const targetHashElement = document.getElementById(elementId);
    if (targetHashElement) {
      // close navbar if open
      if (window.luther && window.luther.navigation) {
        window.luther.navigation.closeOverlay();
      }

      const top =
        targetHashElement.getBoundingClientRect().top + window.scrollY - 250;

      window.scrollTo({
        top,
        left: 0,
        behavior,
      });
    }
  }
});
